// extracted by mini-css-extract-plugin
export var First = "backgroundEffects-module---first--01a26";
export var Second = "backgroundEffects-module---second--a757f";
export var flash = "backgroundEffects-module--flash--4ebc7";
export var fog = "backgroundEffects-module--fog--4db47";
export var fogContainer = "backgroundEffects-module--fog-container--85e36";
export var move = "backgroundEffects-module--move--44c1e";